var serverActions = {
  register : 'create_client_account',
  getActivationToken : 'get_client_activation_token',
  activateAccount: 'activate_client_account'  
};

var serverConnectorService;
var q
var instance

class ClientRegistrationService {
    constructor($q, ServerConnectorService) {
      instance = this;  
      q = $q;
      serverConnectorService = ServerConnectorService;
      this.register = this.register.bind(this);
    }
    
    register(dataStep1){
        var deferred = q.defer();
        var websocket = serverConnectorService.connect();
        var request = {
          action_name : serverActions.register,
          first_name : '',
          last_name : '',
          email :  dataStep1.email.$modelValue,
          password : dataStep1.password.$modelValue,
          language : localStorage['lang'].toUpperCase(),
          phone : ''
        }

        serverConnectorService.send(request, websocket, deferred);
        return deferred.promise;
    }


    activateAccount(email, token){
      var deferred = q.defer();
      console.log('activating account with email ' + email + ' and token ' + token);
      var request = {
        action_name : serverActions.activateAccount,
        email :  email,
        token : token
      }

      var websocket = serverConnectorService.connect();
      serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    static factory($q, ServerConnectorService){
        return new ClientRegistrationService($q, ServerConnectorService);
    }
}

ClientRegistrationService.factory.$inject = ['$q', 'ServerConnectorService'];
export default ClientRegistrationService = ClientRegistrationService.factory


// WEBPACK FOOTER //
// ./src/service/server-connector/clinet-registration.service.js